import constants from '@nike/ciclp-react-components/constants';
import { prepareTranslations as videoTranslations } from './video';
import { getCommonProps, getTitle } from '../helpers/commonHelpers';
import { mergeGalleryProperties } from '../helpers/carouselHelper';

export const prepareCardData = cardData => ({
  ...getCommonProps(cardData),
  // attributeIds used for taxonomy OR logic, param name from product-feeds API
  attributeIds: cardData?.properties?.valueMap?.editorial_taxonomy?.any,
  // attributeIdsAll used for taxonomy AND logic, param name from product-feeds API
  attributeIdsAll:
    cardData?.properties?.valueMap?.editorial ||
    cardData?.properties?.valueMap?.editorial_taxonomy?.all,
  excludeAttributeIds: cardData?.properties?.valueMap?.editorial_taxonomy?.not,
  featured: cardData?.properties?.custom?.selectedFeature,
  maxResults:
    cardData?.properties?.custom?.maxResults ??
    constants.MAX_PRODUCT_LIST_LENGTH,
  sectionHeadline: getTitle(cardData),
  slides: [],
  speed: cardData?.properties?.speed,
});

export const prepareTranslations = (translationsStrings = {}) => ({
  ...videoTranslations(translationsStrings),
  viewAllLabel: translationsStrings.view_all,
});

export { getGalleryUrlIngredients as getUrlIngredients } from '../helpers/carouselHelper/carouselHelper';

export const mergeProperties = ({ cardData, urls, translations, pageType }) => {
  const props = mergeGalleryProperties({
    cardData,
    pageType,
    translations,
    urls,
  });

  if (props?.sectionHeadline?.actions?.[0]?.actionText) {
    props.sectionHeadline.actions[0].actionText = translations.viewAllLabel;
  }
  return props;
};

export {
  getGalleryPlacements as getAnalyticsPlacements,
  getGalleryActions as getAnalyticsActions,
} from '../helpers/analytics';

export { getBuyingToolsIngredients } from './common';
